import React from 'react';
import { withTranslation } from '../../../i18n';
import css from './NavCartButton.module.scss';

const namespacesRequired = ['list'];

const NavCartButton = ({ t, count, onClick }) => {
  return (
    <div className={css.cart}>
      <button type="button"
              className={css.cart__button}
              onClick={onClick}
              aria-label={t('list:cart-modal.selected-products-title', { count })}
      >
        <img src={'/static/images/pictos/icon-shopping-bag.svg'}
             className={css.cart__icon}
             alt=""
        />
      </button>

      {count > 0 && (<span className={css.cart__badge}>{count}</span>)}
    </div>
  );
};

export default withTranslation(namespacesRequired)(NavCartButton);
